import React, { useEffect, useState } from 'react';

// DS
import {
  Col,
  Row,
  VertCarousel,
  VertContainer,
  VertTypography,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/CategoryChipsMenu/CategoryChipsMenuStyles.less';
import 'Assets/styles/default/components/FilterPointsCarroussel/FilterPointsCarroussel.less';
import BoxFilterPoints from './BoxFilterPoints';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { filterTradeMenuByType } from 'Utils/filterTradeMenuByType';

const FilterPointsCarrousel = ({ title, type }) => {
  const isLargeScreen = useMediaQuery({
    query: '(min-width: 1200px)',
  });
  const isExtraSmallScreen = useMediaQuery({ query: '(max-width: 576px)' });
  const CmsStatic = useSelector(({ CmsStatic: data }) => data);
  const [servicesItem, setServicesItem] = useState([]);

  const getFilteredTradeMenu = (CmsStatic, type) => {
    const {
      cms: { tradeMenu },
    } = CmsStatic;
    const targetType = type;
    const filteredItem = filterTradeMenuByType(tradeMenu, targetType);
    return filteredItem;
  };

  useEffect(() => {
    if (CmsStatic?.requestMake && !CmsStatic?.isLoading) {
      const filteredShowcaseItems = getFilteredTradeMenu(CmsStatic, type);
      setServicesItem(filteredShowcaseItems);
    }
  }, [CmsStatic?.requestMake]);
  const showArrows = servicesItem.length > 8;
  const maxSlidesToShow = Math.max(1, servicesItem.length);

  const settings = {
    variableWidth: true,
    slidesToShow: Math.min(9, maxSlidesToShow),
    infinite: servicesItem.length > 3,
    slidesToScroll: 1,
    arrows: servicesItem.length >= 8,
    dots: false,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: Math.min(8, maxSlidesToShow),
          infinite: servicesItem.length > 3,
          slidesToScroll: 1,
          arrows: servicesItem.length >= 8,
        },
      },

      {
        breakpoint: 1400,
        settings: {
          slidesToShow: Math.min(7, maxSlidesToShow),
          infinite: servicesItem.length > 3,
          slidesToScroll: 1,
          arrows: servicesItem.length > 7,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(6, maxSlidesToShow),
          infinite: servicesItem.length > 3,
          slidesToScroll: 1,
          arrows: servicesItem.length > 6,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(isLargeScreen ? 5 : 4, maxSlidesToShow),
          infinite: servicesItem.length > 3,
          slidesToScroll: 1,
          arrows: servicesItem.length > 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(4, maxSlidesToShow),
          slidesToScroll: 1,
          arrows: servicesItem.length > 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: Math.min(isExtraSmallScreen ? 2 : 3, maxSlidesToShow),
          slidesToScroll: isExtraSmallScreen ? 1 : 2,
          arrows: servicesItem.length > 3,
        },
      },
      {
        breakpoint: 280,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: servicesItem.length > 1,
        },
      },
    ],
  };

  return servicesItem.length === 0 ? null : (
    <>
      {title && (
        <VertContainer className="padding-x-regular">
          <Row
            justify="center"
            align="middle"
            className="vert-box-showcase-title padding-x-extra-small"
            gutter={8}
          >
            <Col
              flex="auto"
              className="vert-box-showcase-title-label"
              verticalSpacing="small"
            >
              <VertTypography.Title level={1} className="margin-bottom-none">
                {title}
              </VertTypography.Title>
            </Col>
          </Row>
        </VertContainer>
      )}

      <VertContainer
        fluid
        className="filter-points-carrousel-container"
        spacingY="regular"
      >
        <VertContainer
          className="padding-x-regular"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <VertCarousel
            {...settings}
            style={{
              display: 'flex',
              justifyContent: showArrows ? 'center' : 'space-between',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            {servicesItem.map((item, index) => (
              <BoxFilterPoints
                key={index}
                valuePoints={item.title}
                path={item.path}
                icon={item.icon}
                label={item.label}
              />
            ))}
          </VertCarousel>
        </VertContainer>
      </VertContainer>
    </>
  );
};

export default FilterPointsCarrousel;